import { useState } from "react";

export default function Select({
  label,
  hint,
  error,
  value,
  defaultValue,
  options = [],
  placeholder = "Select…",
  disabled = false,
  id,
  onChange,
  style,
  ...rest
}) {
  const [focus, setFocus] = useState(false);
  const inputId = id || (label ? `sel-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  const borderColor = error ? "var(--danger)" : focus ? "var(--brand)" : "var(--border-default)";

  const wrap = {
    position: "relative",
    display: "flex",
    alignItems: "center",
    background: disabled ? "var(--surface-sunken)" : "var(--surface-raised)",
    border: `1px solid ${borderColor}`,
    borderRadius: "var(--radius-md)",
    height: 46,
    boxShadow: focus && !error ? "var(--shadow-focus)" : "none",
    transition: "border-color var(--dur-base) var(--ease-standard), box-shadow var(--dur-base) var(--ease-standard)",
    opacity: disabled ? 0.6 : 1,
  };

  const field = {
    appearance: "none",
    WebkitAppearance: "none",
    border: "none",
    outline: "none",
    background: "transparent",
    flex: 1,
    width: "100%",
    minWidth: 0,
    height: "100%",
    padding: "0 40px 0 14px",
    fontFamily: "var(--font-body)",
    fontSize: "var(--text-base)",
    color: "var(--text-primary)",
    cursor: disabled ? "not-allowed" : "pointer",
  };

  const norm = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));

  return (
    <label htmlFor={inputId} style={{ display: "block", fontFamily: "var(--font-body)", ...style }}>
      {label && (
        <span style={{ display: "block", fontSize: "var(--text-sm)", fontWeight: "var(--weight-semibold)", color: "var(--text-primary)", marginBottom: 6 }}>
          {label}
        </span>
      )}
      <div style={wrap}>
        <select
          id={inputId}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={onChange}
          style={field}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          {...rest}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {norm.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <svg
          width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)"
          strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
          style={{ position: "absolute", right: 14, pointerEvents: "none" }}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
      {(hint || error) && (
        <span style={{ display: "block", fontSize: "var(--text-xs)", color: error ? "var(--danger)" : "var(--text-muted)", marginTop: 5 }}>
          {error || hint}
        </span>
      )}
    </label>
  );
}
